<template>
  <div>
    <div class="py-2 d-flex flex-wrap mx-0" v-if="editing">
      <special-condition-select
        class="special-condition-select"
        @change="onParameterChanged"
        :dataKeys="['special_condition_id']"
        classes="grey"
      />
      <button
        class="btn btn-link font-weight-semibold text-primary mb-0 my-md-auto mt-auto p-0 ml-3 clickable"
        @click="onSaveClicked"
        :disabled="!valid"
      >
        Aggiungi
      </button>
    </div>
    <div class="py-2 row mx-0 clickable" v-else @click="editing = true">
      <i class="fas fa-plus text-primary my-auto px-0"></i>
      <p
        class="font-weight-semibold text-primary col-4 col-md-3 my-auto px-0 ml-3"
      >
        Aggiungi
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from "vue-property-decorator";
import InlineEditor from "components/InlineEditor.vue";
import OrdersMixin from "mixins/http/OrdersMixin";
import { RegisterHttp } from "utils/Decorators";
import { RequestData } from "store/types";
import NumberInput from "components/NumberInput.vue";
import SpecialConditionSelect from "components/SpecialCondition/Select.vue";

@Component({
  components: { InlineEditor, SpecialConditionSelect, NumberInput },
})
export default class CreateOrderSpecialConditionItem extends Mixins(
  OrdersMixin,
) {
  static readonly createTag = "create_order_special_condition";

  @RegisterHttp(CreateOrderSpecialConditionItem.createTag)
  createRequestd: RequestData;

  @Prop({ required: true })
  orderId: string;

  data: any = {};
  editing: boolean = false;

  get valid() {
    return this.data.special_condition_id;
  }

  reset() {
    this.data.special_condition_id = undefined;
  }

  onParameterChanged(value) {
    this.data = {
      order_id: this.orderId,
      ...this.data,
      ...value,
    };
  }

  onSaveClicked() {
    if (!this.valid) {
      return;
    }

    this.createOrderSpecialCondition(
      this.data,
      CreateOrderSpecialConditionItem.createTag,
    ).then((resp) => {
      this.$emit("created", resp);
      this.reset();
      this.editing = false;
    });
  }
}
</script>

<style scoped>
.special-condition-select {
  width: 450px;
}
</style>
